import React from 'react';

export enum AlertTypes {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  NOTE = 'note',
}

interface PropType {
  alertType: string;
  title: string;
  subtitle?: string;
  dismissable?: boolean;
  closeAlert?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const Alert: React.FunctionComponent<PropType> = (props: PropType) => {
  const { alertType, title, subtitle, dismissable, closeAlert } = props;

  const alertStyle = (type: string): Array<string> => {
    switch (type) {
      case AlertTypes.SUCCESS:
        return [
          'bg-green-light-tint-2',
          'fas fa-check-circle text-green-primary',
        ];
      case AlertTypes.INFO:
        return [
          'bg-celtic-blue-light-tint-2',
          'fas fa-info-circle text-celtic-blue-medium-tint-1',
        ];
      case AlertTypes.WARNING:
        return [
          'bg-yellow-light-tint-2',
          'fas fa-exclamation-circle text-yellow-primary',
        ];
      case AlertTypes.ERROR:
        return ['bg-red-light-tint-2', 'fas fa-times-circle text-red-primary'];
      case AlertTypes.NOTE:
        return [
          'bg-purple-light-tint-2',
          'far fa-lightbulb text-purple-primary',
        ];
      default:
        return [];
        break;
    }
  };

  return (
    <div
      className={`flex flex-row text-white px-6 py-4 border-0 rounded relative mb-2 ${
        alertStyle(alertType)[0]
      }`}
      data-testid={`alert-${alertType}`}
    >
      <div className="text-xl inline-block align-middle">
        <i className={alertStyle(alertType)[1]} />
      </div>
      <div className="pl-4">
        <h5 className="inline-block align-middle ">{title}</h5>
        <p className="body-text-2">{subtitle}</p>
      </div>

      {dismissable && (
        <button
          onClick={closeAlert}
          type="button"
          className="absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 mt-4 mr-6 outline-none focus:outline-none"
        >
          <span>×</span>
        </button>
      )}
    </div>
  );
};

Alert.defaultProps = {
  closeAlert: (): void => {
    //
  },
  dismissable: false,
  subtitle: '',
};

export default Alert;
